<!--
Author: TangChen
Date: 2025-4-23
Desc: 短信认证弹框，为公共组件
 -->
<template>
    <div class="comp-img-code comp">
        <el-dialog
            :title="smsTitle"
            :visible.sync="visible"
            width="800px"
            class="prop"
            v-on:close="dialogClose"
        >
            <!--双因素-->
            <div v-if="smsType !== '3'" style="margin-top: 10px; margin-bottom: 20px">
                <div>尊敬的用户，您好！</div>

                <!--  异常登录start -->
                <div v-if="smsType === '1'" style="text-indent: 2em; line-height: 30px">
                    <div v-if="$util.isEmpty(mobileno) || $util.isEmpty(enMobileno)">
                        <div>
                            {{
                                showRemote ? "系统检测到您的账号最近出现过异常登录，" : ""
                            }}为保障您的账户安全，需进行双重认证，因系统未预留您的手机号，无法发送短信，如需增加手机号，请联系客服{{
                                $cache.getCompanyInfoParam("10101009")
                            }}！
                        </div>
                    </div>
                    <div v-else>
                        {{
                            showRemote ? "系统检测到您的账号最近出现过异常登录，" : ""
                        }}为保障您的账户安全，需进行双重认证，短信验证码将发送至尾号{{
                            mobileno.substring(7)
                        }}的手机，请确认手机号是否还在使用，若已停用，请联系客服{{
                            $cache.getCompanyInfoParam("10101009")
                        }}！
                    </div>
                </div>
                <!--  异常登录end -->

                <!--  交易大额start-->
                <div v-else>
                    <div
                        v-if="$util.isEmpty(mobileno) || $util.isEmpty(enMobileno)"
                        style="text-indent: 2em; line-height: 30px"
                    >
                        为保障您的账户安全，大额交易需进行双重认证，需向您的手机号码发送短信验证码，目前您在我司未预留手机号，请您前往绑定手机号页面增加手机号！
                    </div>
                    <div v-else>
                        为保障您的账户安全，大额交易需进行双重认证，短信验证码将发送至尾号{{
                            mobileno.substring(7)
                        }}的手机，请确认手机号是否还在使用，若已停用，请修改手机号！
                    </div>
                </div>
                <!--  交易大额end -->
            </div>
            <!--双因素-->

            <div
                v-if="
                    ['3'].includes(smsType) ||
                    (!$util.isEmpty(mobileno) && !$util.isEmpty(enMobileno))
                "
                style="display: flex; align-items: center"
            >
                <img src="@/assets/img/msg.png" width="70px" style="margin-right: 60px" />
                <el-form
                    ref="form"
                    label-width="200px"
                    :model="form"
                    :rules="ruleVerify"
                    class="form-contain"
                    v-on:submit.native.prevent
                >
                    <el-form-item
                        v-if="!$util.isEmpty(mobileno) && !$util.isEmpty(enMobileno)"
                        label="您的手机号码："
                    >
                        <div style="display: flex">
                            <div style="width: 180px">
                                {{ $util.maskPhoneNumber(mobileno) }}
                            </div>
                            <a
                                v-if="smsType === '2'"
                                style="margin-left: 30px"
                                v-on:click="
                                    $router.push({
                                        name: 'acctManager',
                                        query: { activeIndex: '2' },
                                        params: { next: 'mobile' }
                                    })
                                "
                            >
                                修改手机号
                            </a>
                        </div>
                    </el-form-item>
                    <el-form-item v-else label="请输入您的手机号码：" prop="mobileno">
                        <el-input
                            v-model.trim="form.mobileno"
                            :maxlength="11"
                            placeholder="请输入您的手机号码"
                        />
                    </el-form-item>
                    <el-form-item
                        v-if="$cache.getSysParam('10103010') == '1'"
                        prop="verifycode"
                        label="请输入附加码："
                    >
                        <div style="display: flex; justify-items: center">
                            <el-input
                                v-model.trim="form.verifycode"
                                placeholder="请输入附加码"
                                :maxlength="4"
                            />
                            <img class="verifyImg" :src="imgSrc" v-on:click="refresh" />
                        </div>
                    </el-form-item>
                    <el-form-item label="请输入短信验证码：" prop="smscode">
                        <div style="display: flex; justify-items: center">
                            <el-input
                                v-model.trim="form.smscode"
                                :maxlength="$cache.getSysParam('10103006')"
                                placeholder="请输入短信验证码"
                            />
                            <el-button
                                style="margin-left: 30px"
                                :class="time > 0 ? 'get-verify-disabled' : 'get-verify'"
                                v-on:click="sendSms"
                            >
                                {{ btnMsg }}
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <el-form slot="footer" class="dialog-footer">
                <el-button
                    v-if="
                        !(smsType === '1' && ($util.isEmpty(mobileno) || $util.isEmpty(enMobileno)))
                    "
                    class="cancelBtn"
                    v-on:click="handleCancel"
                >
                    取 消
                </el-button>
                <el-button
                    v-if="smsType === '2' && ($util.isEmpty(mobileno) || $util.isEmpty(enMobileno))"
                    class="confirmBtn"
                    v-on:click="bindMobile"
                >
                    绑定手机号
                </el-button>
                <el-button v-else class="confirmBtn" v-on:click="submitForm()">确 定</el-button>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import userApi from "@/api/user";

export default {
    name: "SmsValid",
    props: {
        dialogVisible: {
            type: Boolean,
            required: true
        },
        showRemote: {
            type: Boolean,
            required: true
        },
        smsTitle: {
            type: String,
            default: "双重认证"
        },
        smsType: {
            type: String,
            default: "1" // 1登录，2交易，3普通验证
        },
        mobileno: {
            type: String,
            default: ""
        },
        enMobileno: {
            type: String,
            default: ""
        },
        certificateno: {
            type: String,
            default: ""
        },
        custbelongto: {
            type: String,
            default: ""
        },
        bizType: {
            // 默认 this.$const.IMG_BIZTYPE.SMSVALID
            type: String,
            default: ""
        },
        closeWithReset: {
            type: Boolean,
            default: true
        },
        skipVerification: {
            // 跳过校验
            type: String,
            default: ""
        }
    },
    data() {
        return {
            imgSrc: "", // 图片验证码请求地址
            form: {
                mobileno: "",
                verifycode: "",
                smscode: ""
            },
            visible: false, // 是否显示dialog
            ruleVerify: {
                mobileno: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur"
                    },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                verifycode: [
                    {
                        required: true,
                        message: "请输入附加码",
                        trigger: "blur"
                    }
                ],
                smscode: [
                    {
                        required: true,
                        message: "请输入短信验证码",
                        trigger: "blur"
                    },
                    { validator: this.$util.validateVerifyCode, trigger: "blur" }
                ]
            },
            time: 0,
            btnMsg: "获取验证码",
            isClosing: false, // 防止重复调用 dialogClose
            isCanceled: false // 标记是否是点击取消按钮
        };
    },
    watch: {
        dialogVisible(val) {
            this.visible = val;
            if (!val) {
                this.$refs["form"].resetFields();
            } else {
                this.refresh();
            }
        }
    },
    methods: {
        hasReservedMobile() {
            return !this.$util.isEmpty(this.mobileno) && !this.$util.isEmpty(this.enMobileno);
        },
        /* 刷新验证码图片 */
        refresh() {
            this.$util.imgUrl(this.bizType || this.$const.IMG_BIZTYPE.SMSVALID).then((res) => {
                this.imgSrc = res.data.image;
            });
        },
        validateField(key) {
            let flag = false;
            this.$refs["form"].validateField([key], (valid) => {
                if (valid) {
                    this.$message({
                        type: "error",
                        message: valid
                    });
                } else {
                    flag = true;
                }
            });
            return flag;
        },
        async sendSms() {
            if (this.time > 0) return;
            if (!this.hasReservedMobile()) {
                if (this.validateField("mobileno")) {
                    if (this.$cache.getSysParam("10103010") == "1") {
                        if (!this.validateField("verifycode")) {
                            return;
                        }
                    }
                } else {
                    return;
                }
            } else {
                if (this.$cache.getSysParam("10103010") == "1") {
                    if (!this.validateField("verifycode")) {
                        return;
                    }
                }
            }
            let param = {
                biztype: this.bizType || this.$const.IMG_BIZTYPE.SMSVALID,
                verifycode: this.form.verifycode
            };
            if (!this.hasReservedMobile()) {
                param["mobileno"] = this.form.mobileno;
            } else {
                param["en_mobileno"] = this.enMobileno;
            }
            const res = await userApi.sendSms(param, this.hasReservedMobile());
            if (res.code === "0") {
                /* 倒计时 */
                this.time = res.data.sendperiod;
                this.$util.btnDisabled(this);
            } else {
                this.$message({
                    type: "warning",
                    message: res.msg
                });
            }
        },
        /* 提交表单数据 */
        async submitForm() {
            if (
                this.smsType === "1" &&
                (this.$util.isEmpty(this.mobileno) || this.$util.isEmpty(this.enMobileno))
            ) {
                this.dialogClose();
                return;
            }
            if (this.time === 0) {
                this.$message({
                    type: "error",
                    message: "请先获取验证码"
                });
                return;
            }
            if (
                this.smsType === "1" &&
                (this.$util.isEmpty(this.mobileno) || this.$util.isEmpty(this.enMobileno))
            ) {
                if (this.validateField("mobileno")) {
                    if (this.$cache.getSysParam("10103010") == "1") {
                        if (this.validateField("verifycode")) {
                            if (!this.validateField("smscode")) {
                                return;
                            }
                        } else {
                            return;
                        }
                    }
                } else {
                    return;
                }
            } else if (this.$cache.getSysParam("10103010") == "1") {
                if (this.validateField("verifycode")) {
                    if (!this.validateField("smscode")) {
                        return;
                    }
                } else {
                    return;
                }
            } else {
                if (!this.validateField("smscode")) {
                    return;
                }
            }
            // 注销未开户用到 直接直接把验证码返回出去
            if (this.skipVerification == "1") {
                this.$emit("sms-comfirm", this.form.smscode);
                this.dialogClose();
                return;
            }
            let res = await userApi.checkSmsCode({
                smscode: this.form.smscode,
                biztype: this.bizType || this.$const.IMG_BIZTYPE.SMSVALID
            });
            if (res.code === "0") {
                if (
                    this.smsType === "1" &&
                    (this.$util.isEmpty(this.mobileno) || this.$util.isEmpty(this.enMobileno))
                ) {
                    const res1 = await userApi.bindMobileno({
                        mobileno: this.form.mobileno,
                        certificateno: this.certificateno
                    });
                    if (res1.code === "0") {
                        this.$emit("sms-comfirm");
                        this.dialogClose();
                    }
                } else {
                    this.$emit("sms-comfirm", this.form.smscode);
                    this.dialogClose();
                }
            } else {
                this.$message({
                    type: "warning",
                    message: res.msg
                });
            }
        },
        async handleCancel() {
            // 点击取消按钮，标记为取消状态
            this.isCanceled = true;
            this.dialogClose();
        },
        async dialogClose() {
            // 防止重复调用
            if (this.isClosing) return;
            this.isClosing = true;

            // 如果是登录双因素验证（smsType === '1'）且是点击取消按钮，才调用登出接口
            if (this.smsType === "1" && this.isCanceled) {
                try {
                    await userApi.logout();
                } catch (e) {
                    console.error("logout error:", e);
                }
            }

            this.$emit("close");
            if (this.closeWithReset) {
                this.form = {
                    mobileno: "",
                    verifycode: "",
                    smscode: ""
                };
                this.time = 0;
                this.btnMsg = "获取验证码";
                this.$util.btnDisabled(this);
            }

            // 重置标志位
            this.$nextTick(() => {
                this.isClosing = false;
                this.isCanceled = false;
            });
        },
        bindMobile() {
            this.$router.push({
                name: "acctManager",
                query: { activeIndex: "2" },
                params: { next: "mobile" }
            });
            sessionStorage.setItem("backUrl", location.href);
        }
    }
};
</script>
<style lang="scss" scoped>
.comp-img-code {
    background: #ffffff;

    .verifyImg {
        width: 112px;
        height: 38px;
        cursor: pointer;
        margin-left: 30px;
    }

    .prop-text {
        font-size: 16px;
        font-weight: normal;
        color: #333333;
    }

    .cancelBtn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: #e4e4e4;
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        border: 1px solid #e4e4e4;
        cursor: pointer;
    }

    .confirmBtn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: var(--color-primary);
        color: #ffffff;
        font-size: 16px;
        font-weight: 500;
        border: 1px solid var(--color-primary);
        cursor: pointer;
    }

    :deep(.el-input__inner) {
        width: 180px;
    }

    :deep(.el-dialog__header) {
        height: 40px;
        border-radius: 6px 6px 0px 0px;
        box-sizing: border-box;
        position: relative;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .el-dialog__headerbtn {
            position: relative;
            width: 19.99px;
            height: 19.99px;
            background: #ffffff;
            border: 1px solid #999999;
            box-sizing: border-box;
        }

        .el-dialog__headerbtn:hover {
            border: 1px solid var(--color-primary);
        }

        .el-icon-close {
            color: #999999;
        }

        .el-icon-close:before {
            color: #999999;
            font-size: 18px;
        }

        .el-icon-close:hover:before {
            color: var(--color-primary) !important;
        }
    }
    :deep(.el-dialog__body) {
        padding: 20px 40px;
    }
    :deep(.el-form-item__error) {
        display: none;
    }
    .get-verify {
        color: var(--color-text-white);
        background: var(--color-primary);
        border-color: var(--color-primary);
        cursor: pointer;
    }
    .get-verify:hover {
        background: var(--color-primary);
        border-color: var(--color-primary);
        color: var(--color-text-white);
    }
    .get-verify-disabled {
        cursor: not-allowed;
        background-color: var(--color-primary);
        border-color: var(--color-primary);
        color: var(--color-text-white);
        opacity: 0.4;
    }
    .get-verify-disabled:hover {
        color: var(--color-text-white);
        background-color: var(--color-primary);
        border-color: var(--color-primary);
    }
}
</style>
